// // src/pages/AdminPage.js
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { isAdmin } from "../utils/auth";
// import { useAuth } from "../context/AuthContext";
// import { signOut } from "../utils/auth";
// import EditUserModal from "../components/EditUserModal";
// import { updateUserPreferences, deleteUser } from "../api/adminApi";
// import { createUser } from "../api/adminApi"; // NEW
// import CreateUserModal from "./CreateUserModal";

// const AdminPage = () => {
//   const navigate = useNavigate();
//   const { user, login } = useAuth();
//   const users = user?.users || [];
//   const [editingUser, setEditingUser] = useState(null);
//    const [isCreating, setIsCreating] = useState(false); // NEW

//   useEffect(() => {
//     if (!isAdmin()) {
//       navigate("/", { replace: true });
//     }
//   }, [navigate]);

//   if (!isAdmin()) {
//     return null;
//   }

//   const handleSignOut = () => {
//     if (window.confirm("Are you sure you want to sign out?")) {
//       signOut();
//       alert("Signed out successfully.");
//       navigate("/");
//     }
//   };

//   const handleSaveUser = async (updatedData) => {
//     const result = await updateUserPreferences(updatedData);

//     // Update local state
//     const updatedUsers = users.map((u) => {
//       if (u.user.customer_id === updatedData.customer_id) {
//         return {
//           ...u,
//           user: {
//             ...u.user,
//             email: updatedData.email,
//             age: updatedData.age,
//             first_name: updatedData.first_name,
//           },
//           preferences: {
//             ...u.preferences,
//             ...updatedData,
//           },
//         };
//       }
//       return u;
//     });

//     login({ ...user, users: updatedUsers });
//   };

//   const handleDeleteUser = async (customer_id, email) => {
//     if (
//       !window.confirm(
//         `Are you sure you want to delete user ${email}? This cannot be undone.`
//       )
//     ) {
//       return;
//     }

//     try {
//       await deleteUser(customer_id);

//       // Remove user from local state
//       const updatedUsers = users.filter(
//         (userItem) => userItem.user.customer_id !== customer_id
//       );

//       // Update context
//       login({ ...user, users: updatedUsers });

//       alert("User deleted successfully.");
//     } catch (error) {
//       console.error("Delete failed:", error);
//       alert("Failed to delete user: " + error.message);
//     }
//   };

// const handleCreateUser = async (userData) => {
//   try {
//     const newUser = await createUser(userData);

//     // Add new user to local state
//     const newUserItem = {
//       user: {
//         ...userData.user,
//         customer_id: newUser.customer_id, // assuming API returns this
//         id: Date.now(), // temporary ID
//         user_role: "C",
//       },
//       preferences: userData.preferences,
//     };

//     const updatedUsers = [...users, newUserItem];
//     login({ ...user, users: updatedUsers });

//     alert("User created successfully!");
//   } catch (error) {
//     alert("Failed to create user: " + error.message);
//   }
// };
//   return (
//     <div className="p-4 sm:p-6 max-w-6xl mx-auto">
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
//         <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//           Admin Dashboard
//         </h1>
//       <button
//   onClick={() => setIsCreating(true)}
//   className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
// >
//   + Create User
// </button>
//       </div>

//       <button
//         onClick={handleSignOut}
//         className="block text-left text-sm text-red-600 hover:underline mb-6"
//       >
//         SIGN OUT
//       </button>

//       <p className="text-gray-600 mb-6">
//         Total users: <span className="font-semibold">{users.length}</span>
//       </p>

//       <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   User
//                 </th>
//                 <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Email
//                 </th>
//                 <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Preferences
//                 </th>
//                 <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {users.length > 0 ? (
//                 users.map((userItem) => {
//                   const { user: u, preferences } = userItem;
//                   return (
//                     <tr key={u.id} className="hover:bg-gray-50">
//                       <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
//                         <div className="text-sm font-medium text-gray-900">
//                           {u.first_name} {u.last_name}
//                         </div>
//                         <div className="text-sm text-gray-500">
//                           @{u.username}
//                         </div>
//                       </td>
//                       <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {u.email}
//                       </td>
//                       <td className="px-4 sm:px-6 py-4 text-sm text-gray-700">
//                         <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
//                           <div>
//                             <span className="font-medium">Apparel:</span>{" "}
//                             {preferences.apparel_preference}
//                           </div>
//                           <div>
//                             <span className="font-medium">Size:</span>{" "}
//                             {preferences.clothing_size}
//                           </div>
//                           <div>
//                             <span className="font-medium">Color:</span>{" "}
//                             {preferences.color_preference}
//                           </div>
//                           <div>
//                             <span className="font-medium">Tone:</span>{" "}
//                             {preferences.color_tone_preference}
//                           </div>
//                         </div>
//                       </td>
//                       <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm space-x-3">
//                         {/* Edit Icon */}
//                         <button
//                           onClick={() =>
//                             setEditingUser({ user: u, preferences })
//                           }
//                           className="text-blue-600 hover:text-blue-800 p-1"
//                           aria-label="Edit user"
//                         >
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="h-5 w-5"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                           >
//                             <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
//                           </svg>
//                         </button>

//                         <button
//                           onClick={() =>
//                             handleDeleteUser(u.customer_id, u.email)
//                           }
//                           className="text-red-600 hover:text-red-800 p-1"
//                           aria-label="Delete user"
//                         >
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="h-5 w-5"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                           >
//                             <path
//                               fillRule="evenodd"
//                               d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
//                               clipRule="evenodd"
//                             />
//                           </svg>
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="4"
//                     className="px-6 py-8 text-center text-gray-500"
//                   >
//                     No users found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {editingUser && (
//         <EditUserModal
//           user={editingUser.user}
//           preferences={editingUser.preferences}
//           onClose={() => setEditingUser(null)}
//           onSave={handleSaveUser}
//         />
//       )}

//       {isCreating && (
//   <CreateUserModal
//     onClose={() => setIsCreating(false)}
//     onCreate={handleCreateUser}
//   />
// )}
//     </div>
//   );
// };

// export default AdminPage;

// import { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { isAdmin } from "../utils/auth";
// import { useAuth } from "../context/AuthContext";
// import { signOut } from "../utils/auth";
// import EditUserModal from "../components/EditUserModal";
// import { updateUserPreferences, deleteUser, createUser, fetchProducts } from "../api/adminApi";
// import CreateUserModal from "./CreateUserModal";

// const AdminPage = () => {
//   const navigate = useNavigate();
//   const { user, login } = useAuth();
//   const users = user?.users || [];

//   // State for tabs & products
//   const [activeTab, setActiveTab] = useState("users"); // "users" | "products"
//   const [editingUser, setEditingUser] = useState(null);
//   const [isCreating, setIsCreating] = useState(false);

//   // Product state
//   const [products, setProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(false);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     pageSize: 50,
//     totalPages: 1,
//     totalRecords: 0,
//   });

//   // Guard against non-admins (runs on every render)
//   useEffect(() => {
//     if (!isAdmin()) {
//       navigate("/", { replace: true });
//     }
//   }, [navigate]);

//   // Fetch products (memoized to prevent unnecessary re-creation)
//   const loadProducts = useCallback(async (page = 1, size = 50) => {
//     setLoadingProducts(true);
//     try {
//       const data = await fetchProducts(page, size);
//       setProducts(data.products);
//       setPagination({
//         currentPage: data.currentPage,
//         pageSize: data.pageSize,
//         totalPages: data.totalPages,
//         totalRecords: data.totalRecords,
//       });
//     } catch (error) {
//       console.error("Failed to load products", error);
//       alert("Failed to load products: " + error.message);
//     } finally {
//       setLoadingProducts(false);
//     }
//   }, []);

//   // Load products when switching to "products" tab
//   useEffect(() => {
//     if (activeTab === "products" && products.length === 0) {
//       loadProducts(1, 50);
//     }
//   }, [activeTab, products.length, loadProducts]);

//   // 🚪 Sign out
//   const handleSignOut = () => {
//     if (window.confirm("Are you sure you want to sign out?")) {
//       signOut();
//       alert("Signed out successfully.");
//       navigate("/");
//     }
//   };

//   // Edit user
//   const handleSaveUser = async (updatedData) => {
//     try {
//       await updateUserPreferences(updatedData);
//       const updatedUsers = users.map((u) =>
//         u.user.customer_id === updatedData.customer_id
//           ? {
//               ...u,
//               user: {
//                 ...u.user,
//                 email: updatedData.email,
//                 age: updatedData.age,
//                 first_name: updatedData.first_name,
//               },
//               preferences: {
//                 ...u.preferences,
//                 ...updatedData,
//               },
//             }
//           : u
//       );
//       login({ ...user, users: updatedUsers });
//     } catch (err) {
//       alert("Failed to update user: " + err.message);
//     }
//   };

//   // Delete user
//   const handleDeleteUser = async (customer_id, email) => {
//     if (!window.confirm(`Are you sure you want to delete user ${email}?`)) return;

//     try {
//       await deleteUser(customer_id);
//       const updatedUsers = users.filter((u) => u.user.customer_id !== customer_id);
//       login({ ...user, users: updatedUsers });
//       alert("User deleted successfully.");
//     } catch (error) {
//       console.error("Delete failed:", error);
//       alert("Failed to delete user: " + error.message);
//     }
//   };

//   // ➕ Create user
//   const handleCreateUser = async (userData) => {
//     try {
//       const newUser = await createUser(userData);
//       const newUserItem = {
//         user: {
//           ...userData.user,
//           customer_id: newUser.customer_id,
//           id: Date.now(),
//           user_role: "C",
//         },
//         preferences: userData.preferences,
//       };
//       login({
//         ...user,
//         users: [...users, newUserItem],
//       });
//       alert("User created successfully!");
//       setIsCreating(false);
//     } catch (error) {
//       alert("Failed to create user: " + error.message);
//     }
//   };

//   // Pagination
//   const goToPage = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       loadProducts(page, pagination.pageSize);
//     }
//   };

//   const nextPage = () => goToPage(pagination.currentPage + 1);
//   const prevPage = () => goToPage(pagination.currentPage - 1);

//   // Early return (after hooks)
//   if (!isAdmin()) {
//     return null;
//   }

//   return (
//     <div className="p-4 sm:p-6 max-w-7xl mx-auto">
//       {/* TABS */}
//       <div className="flex flex-wrap gap-2 mb-6 border-b">
//         <button
//           onClick={() => setActiveTab("users")}
//           className={`px-4 py-2 font-medium rounded-t-lg ${
//             activeTab === "users"
//               ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           User Management
//         </button>
//         <button
//           onClick={() => setActiveTab("products")}
//           className={`px-4 py-2 font-medium rounded-t-lg ${
//             activeTab === "products"
//               ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Product Management
//         </button>
//       </div>

//       {/* USER MANAGEMENT (default) */}
//       {activeTab === "users" && (
//         <>
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//               Admin Dashboard — Users
//             </h1>
//             <button
//               onClick={() => setIsCreating(true)}
//               className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
//             >
//               + Create User
//             </button>
//           </div>

//           <button
//             onClick={handleSignOut}
//             className="block text-left text-sm text-red-600 hover:underline mb-6"
//           >
//             SIGN OUT
//           </button>

//           <p className="text-gray-600 mb-6">
//             Total users: <span className="font-semibold">{users.length}</span>
//           </p>

//           <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       User
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Email
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Preferences
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {users.length > 0 ? (
//                     users.map((userItem) => {
//                       const { user: u, preferences } = userItem;
//                       return (
//                         <tr key={u.id || u.customer_id} className="hover:bg-gray-50">
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
//                             <div className="text-sm font-medium text-gray-900">
//                               {u.first_name} {u.last_name}
//                             </div>
//                             <div className="text-sm text-gray-500">@{u.username}</div>
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                             {u.email}
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 text-sm text-gray-700">
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
//                               <div>
//                                 <span className="font-medium">Apparel:</span>{" "}
//                                 {preferences.apparel_preference}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Size:</span>{" "}
//                                 {preferences.clothing_size}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Color:</span>{" "}
//                                 {preferences.color_preference}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Tone:</span>{" "}
//                                 {preferences.color_tone_preference}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm space-x-3">
//                             <button
//                               onClick={() => setEditingUser({ user: u, preferences })}
//                               className="text-blue-600 hover:text-blue-800 p-1"
//                               aria-label="Edit user"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 className="h-5 w-5"
//                                 viewBox="0 0 20 20"
//                                 fill="currentColor"
//                               >
//                                 <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
//                               </svg>
//                             </button>
//                             <button
//                               onClick={() => handleDeleteUser(u.customer_id, u.email)}
//                               className="text-red-600 hover:text-red-800 p-1"
//                               aria-label="Delete user"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 className="h-5 w-5"
//                                 viewBox="0 0 20 20"
//                                 fill="currentColor"
//                               >
//                                 <path
//                                   fillRule="evenodd"
//                                   d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
//                                   clipRule="evenodd"
//                                 />
//                               </svg>
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
//                         No users found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </>
//       )}

//       {/* PRODUCT MANAGEMENT */}
//       {activeTab === "products" && (
//         <>
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Product Management</h1>
//             <p className="text-sm text-gray-600">
//               Showing <span className="font-semibold">{products.length}</span> of{" "}
//               <span className="font-semibold">{pagination.totalRecords}</span> products
//             </p>
//           </div>

//           {loadingProducts ? (
//             <div className="flex justify-center py-12">
//               <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//             </div>
//           ) : products.length === 0 ? (
//             <p className="text-gray-500 text-center py-10">No products found.</p>
//           ) : (
//             <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         ID
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Name
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Price
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Stock
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Color
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Category
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {products.map((p) => (
//                       <tr key={p.article_id} className="hover:bg-gray-50">
//                         <td className="px-4 sm:px-6 py-3 text-sm font-mono text-gray-700">
//                           {p.article_id}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm font-medium text-gray-900">
//                           {p.enhanced_prod_name || p.prod_name}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-900">
//                           ${parseFloat(p.price).toFixed(2)}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm">
//                           <span
//                             className={`px-2 py-1 rounded-full text-xs ${
//                               p.quantity > 0
//                                 ? "bg-green-100 text-green-800"
//                                 : "bg-red-100 text-red-800"
//                             }`}
//                           >
//                             {p.quantity} in stock
//                           </span>
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-700">
//                           {p.perceived_colour_master_name} ({p.perceived_colour_value_name})
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-600 truncate max-w-xs">
//                           {p.section_name}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* PAGINATION CONTROLS */}
//               <div className="px-4 py-3 bg-gray-50 flex items-center justify-between border-t border-gray-200">
//                 <div className="text-sm text-gray-700">
//                   Showing{" "}
//                   <span className="font-medium">
//                     {(pagination.currentPage - 1) * pagination.pageSize + 1}
//                   </span>{" "}
//                   to{" "}
//                   <span className="font-medium">
//                     {Math.min(
//                       pagination.currentPage * pagination.pageSize,
//                       pagination.totalRecords
//                     )}
//                   </span>{" "}
//                   of <span className="font-medium">{pagination.totalRecords}</span> results
//                 </div>
//                 <div className="flex flex-wrap gap-1 sm:gap-2">
//                   <button
//                     onClick={prevPage}
//                     disabled={pagination.currentPage <= 1}
//                     className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     Prev
//                   </button>
//                   {[...Array(Math.min(5, pagination.totalPages))].map((_, i) => {
//                     const pageNum = i + 1;
//                     return (
//                       <button
//                         key={pageNum}
//                         onClick={() => goToPage(pageNum)}
//                         className={`px-3 py-1 rounded-md text-sm font-medium ${
//                           pageNum === pagination.currentPage
//                             ? "bg-blue-600 text-white"
//                             : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
//                         }`}
//                       >
//                         {pageNum}
//                       </button>
//                     );
//                   })}
//                   <button
//                     onClick={nextPage}
//                     disabled={pagination.currentPage >= pagination.totalPages}
//                     className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </>
//       )}

//       {/* Modals */}
//       {editingUser && (
//         <EditUserModal
//           user={editingUser.user}
//           preferences={editingUser.preferences}
//           onClose={() => setEditingUser(null)}
//           onSave={handleSaveUser}
//         />
//       )}
//       {isCreating && (
//         <CreateUserModal
//           onClose={() => setIsCreating(false)}
//           onCreate={handleCreateUser}
//         />
//       )}
//     </div>
//   );
// };

// export default AdminPage;

// import { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { isAdmin } from "../utils/auth";
// import { useAuth } from "../context/AuthContext";
// import { signOut } from "../utils/auth";
// import EditUserModal from "../components/EditUserModal";
// import CreateUserModal from "./CreateUserModal";

// // Import all APIs (ensure `updateProduct`, `enrichProduct`, `updateEnrichedProduct` are added in `adminApi.js`)
// import {
//   updateUserPreferences,
//   deleteUser,
//   createUser,
//   fetchProducts,
//   updateProduct,
//   enrichProduct,
//   updateEnrichedProduct,
// } from "../api/adminApi";

// const AdminPage = () => {
//   const navigate = useNavigate();
//   const { user, login } = useAuth();
//   const users = user?.users || [];

//   // Tab & product state
//   const [activeTab, setActiveTab] = useState("users");
//   const [editingUser, setEditingUser] = useState(null);
//   const [isCreating, setIsCreating] = useState(false);

//   // Product management
//   const [products, setProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(false);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     pageSize: 50,
//     totalPages: 1,
//     totalRecords: 0,
//   });

//   // Product detail modal
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [promptInput, setPromptInput] = useState("");
//   const [enrichedDescription, setEnrichedDescription] = useState("");
//   const [isEnriching, setIsEnriching] = useState(false);
//   const [isUpdatingEnriched, setIsUpdatingEnriched] = useState(false);

//   // Edit product modal
//   const [isEditingProduct, setIsEditingProduct] = useState(false);
//   const [editProductData, setEditProductData] = useState(null);
//   const [isUpdatingProduct, setIsUpdatingProduct] = useState(false);

//   // Redirect non-admins
//   useEffect(() => {
//     if (!isAdmin()) {
//       navigate("/", { replace: true });
//     }
//   }, [navigate]);

//   // Load products
//   const loadProducts = useCallback(async (page = 1, size = 50) => {
//     setLoadingProducts(true);
//     try {
//       const data = await fetchProducts(page, size);
//       setProducts(data.products);
//       setPagination({
//         currentPage: data.currentPage,
//         pageSize: data.pageSize,
//         totalPages: data.totalPages,
//         totalRecords: data.totalRecords,
//       });
//     } catch (error) {
//       console.error("Failed to load products", error);
//       alert(
//         "Failed to load products: " + (error.message || "Unknown error")
//       );
//     } finally {
//       setLoadingProducts(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (activeTab === "products" && products.length === 0) {
//       loadProducts(1, 50);
//     }
//   }, [activeTab, products.length, loadProducts]);

//   // 🚪 Sign out
//   const handleSignOut = () => {
//     if (window.confirm("Are you sure you want to sign out?")) {
//       signOut();
//       alert("Signed out successfully.");
//       navigate("/");
//     }
//   };

//   // Save user
//   const handleSaveUser = async (updatedData) => {
//     try {
//       await updateUserPreferences(updatedData);
//       const updatedUsers = users.map((u) =>
//         u.user.customer_id === updatedData.customer_id
//           ? {
//               ...u,
//               user: {
//                 ...u.user,
//                 email: updatedData.email,
//                 age: updatedData.age,
//                 first_name: updatedData.first_name,
//                 last_name: updatedData.last_name,
//               },
//               preferences: {
//                 ...u.preferences,
//                 ...updatedData,
//               },
//             }
//           : u
//       );
//       login({ ...user, users: updatedUsers });
//       setEditingUser(null);
//     } catch (err) {
//       alert("Failed to update user: " + (err.message || "Unknown error"));
//     }
//   };

//   // Delete user
//   const handleDeleteUser = async (customer_id, email) => {
//     if (!window.confirm(`Delete user ${email}?`)) return;
//     try {
//       await deleteUser(customer_id);
//       const updatedUsers = users.filter(
//         (u) => u.user.customer_id !== customer_id
//       );
//       login({ ...user, users: updatedUsers });
//       alert("User deleted successfully.");
//     } catch (error) {
//       alert("Delete failed: " + (error.message || "Unknown error"));
//     }
//   };

//   // ➕ Create user
//   const handleCreateUser = async (userData) => {
//     try {
//       const newUser = await createUser(userData);
//       const newUserItem = {
//         user: {
//           ...userData.user,
//           customer_id: newUser.customer_id,
//           id: Date.now(),
//           user_role: "C",
//         },
//         preferences: userData.preferences,
//       };
//       login({ ...user, users: [...users, newUserItem] });
//       alert("User created successfully!");
//       setIsCreating(false);
//     } catch (error) {
//       alert("Create failed: " + (error.message || "Unknown error"));
//     }
//   };

//   // Pagination
//   const goToPage = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       loadProducts(page, pagination.pageSize);
//     }
//   };
//   const nextPage = () => goToPage(pagination.currentPage + 1);
//   const prevPage = () => goToPage(pagination.currentPage - 1);

//   if (!isAdmin()) return null;

//   return (
//     <div className="p-4 sm:p-6 max-w-7xl mx-auto">
//       {/* Tabs */}
//     <div className="flex flex-wrap items-center gap-2 mb-6 border-b">
//   {/* Tabs */}
//   <button
//     onClick={() => setActiveTab("users")}
//     className={`px-4 py-2 font-medium rounded-t-lg ${
//       activeTab === "users"
//         ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
//         : "text-gray-500 hover:text-gray-700"
//     }`}
//   >
//     User Management
//   </button>
//   <button
//     onClick={() => setActiveTab("products")}
//     className={`px-4 py-2 font-medium rounded-t-lg ${
//       activeTab === "products"
//         ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
//         : "text-gray-500 hover:text-gray-700"
//     }`}
//   >
//     Product Management
//   </button>

//   {/* Right-aligned Sign Out button */}
//   <button
//     onClick={handleSignOut}
//     className="ml-auto px-3 py-2 text-sm font-medium text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition self-center"
//     aria-label="Sign out"
//   >
//      Sign out
//   </button>
// </div>

//       {/* 👤 Users Tab */}
//       {activeTab === "users" && (
//         <>
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//               User Management
//             </h1>
//             <button
//               onClick={() => setIsCreating(true)}
//               className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
//             >
//               + Create User
//             </button>
//           </div>
//           <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       User
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Email
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Preferences
//                     </th>
//                     <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {users.length > 0 ? (
//                     users.map((userItem) => {
//                       const { user: u, preferences } = userItem;
//                       return (
//                         <tr
//                           key={u.id || u.customer_id}
//                           className="hover:bg-gray-50"
//                         >
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
//                             <div className="text-sm font-medium text-gray-900">
//                               {u.first_name} {u.last_name}
//                             </div>
//                             <div className="text-sm text-gray-500">
//                               @{u.username}
//                             </div>
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                             {u.email}
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 text-sm text-gray-700">
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
//                               <div>
//                                 <span className="font-medium">Apparel:</span>{" "}
//                                 {preferences.apparel_preference}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Size:</span>{" "}
//                                 {preferences.clothing_size}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Color:</span>{" "}
//                                 {preferences.color_preference}
//                               </div>
//                               <div>
//                                 <span className="font-medium">Tone:</span>{" "}
//                                 {preferences.color_tone_preference}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm space-x-3">
//                             <button
//                               onClick={() =>
//                                 setEditingUser({ user: u, preferences })
//                               }
//                               className="text-blue-600 hover:text-blue-800 p-1"
//                               aria-label="Edit user"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 className="h-5 w-5"
//                                 viewBox="0 0 20 20"
//                                 fill="currentColor"
//                               >
//                                 <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
//                               </svg>
//                             </button>
//                             <button
//                               onClick={() =>
//                                 handleDeleteUser(u.customer_id, u.email)
//                               }
//                               className="text-red-600 hover:text-red-800 p-1"
//                               aria-label="Delete user"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 className="h-5 w-5"
//                                 viewBox="0 0 20 20"
//                                 fill="currentColor"
//                               >
//                                 <path
//                                   fillRule="evenodd"
//                                   d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
//                                   clipRule="evenodd"
//                                 />
//                               </svg>
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="4"
//                         className="px-6 py-8 text-center text-gray-500"
//                       >
//                         No users found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Products Tab */}
//       {activeTab === "products" && (
//         <>
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//               Product Management
//             </h1>
//             <p className="text-sm text-gray-600">
//               Showing <span className="font-semibold">{products.length}</span>{" "}
//               of{" "}
//               <span className="font-semibold">{pagination.totalRecords}</span>{" "}
//               products
//             </p>
//           </div>

//           {loadingProducts ? (
//             <div className="flex justify-center py-12">
//               <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//             </div>
//           ) : products.length === 0 ? (
//             <p className="text-gray-500 text-center py-10">
//               No products found.
//             </p>
//           ) : (
//             <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Article ID
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Name
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Price
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Stock
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Color
//                       </th>
//                       <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Category
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {products.map((p) => (
//                       <tr
//                         key={p.article_id}
//                         className="hover:bg-gray-50 cursor-pointer"
//                         onClick={() => setSelectedProduct(p)}
//                       >
//                         <td className="px-4 sm:px-6 py-3 text-sm font-mono text-gray-700">
//                           {p.article_id}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm font-medium text-gray-900">
//                           {p.enhanced_prod_name || p.prod_name}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-900">
//                           ${parseFloat(p.price).toFixed(2)}
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm">
//                           <span
//                             className={`px-2 py-1 rounded-full text-xs ${
//                               p.quantity > 0
//                                 ? "bg-green-100 text-green-800"
//                                 : "bg-red-100 text-red-800"
//                             }`}
//                           >
//                             {p.quantity} in stock
//                           </span>
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-700">
//                           {p.perceived_colour_master_name} (
//                           {p.perceived_colour_value_name})
//                         </td>
//                         <td className="px-4 sm:px-6 py-3 text-sm text-gray-600 truncate max-w-xs">
//                           {p.section_name}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               <div className="px-4 py-3 bg-gray-50 flex items-center justify-between border-t border-gray-200">
//                 <div className="text-sm text-gray-700">
//                   Showing{" "}
//                   <span className="font-medium">
//                     {(pagination.currentPage - 1) * pagination.pageSize + 1}
//                   </span>{" "}
//                   to{" "}
//                   <span className="font-medium">
//                     {Math.min(
//                       pagination.currentPage * pagination.pageSize,
//                       pagination.totalRecords
//                     )}
//                   </span>{" "}
//                   of{" "}
//                   <span className="font-medium">{pagination.totalRecords}</span>{" "}
//                   results
//                 </div>
//                 <div className="flex flex-wrap gap-1 sm:gap-2">
//                   <button
//                     onClick={prevPage}
//                     disabled={pagination.currentPage <= 1}
//                     className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     Prev
//                   </button>
//                   {[...Array(Math.min(5, pagination.totalPages))].map(
//                     (_, i) => {
//                       const pageNum = i + 1;
//                       return (
//                         <button
//                           key={pageNum}
//                           onClick={() => goToPage(pageNum)}
//                           className={`px-3 py-1 rounded-md text-sm font-medium ${
//                             pageNum === pagination.currentPage
//                               ? "bg-blue-600 text-white"
//                               : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     }
//                   )}
//                   <button
//                     onClick={nextPage}
//                     disabled={pagination.currentPage >= pagination.totalPages}
//                     className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </>
//       )}

//       {/* MODALS */}

//       {editingUser && (
//         <EditUserModal
//           user={editingUser.user}
//           preferences={editingUser.preferences}
//           onClose={() => setEditingUser(null)}
//           onSave={handleSaveUser}
//         />
//       )}

//       {isCreating && (
//         <CreateUserModal
//           onClose={() => setIsCreating(false)}
//           onCreate={handleCreateUser}
//         />
//       )}

//       {/* 🧾 Product Detail Modal */}
//       {selectedProduct && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//           <div className="bg-white rounded-xl shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-start mb-4">
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   {selectedProduct.enhanced_prod_name ||
//                     selectedProduct.prod_name}
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setSelectedProduct(null);
//                     setPromptInput("");
//                     setEnrichedDescription("");
//                   }}
//                   className="text-gray-500 hover:text-gray-700"
//                   aria-label="Close"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                 <div>
//                   <img
//                     src={
//                       selectedProduct.image_url?.trim() ||
//                       "https://via.placeholder.com/300?text=No+Image"
//                     }
//                     alt={selectedProduct.prod_name}
//                     className="w-full h-64 object-contain bg-gray-100 rounded-lg"
//                     onError={(e) =>
//                       (e.currentTarget.src =
//                         "https://via.placeholder.com/300?text=Image+Error")
//                     }
//                   />
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-600 mb-1">
//                     Article ID:{" "}
//                     <span className="font-mono">
//                       {selectedProduct.article_id}
//                     </span>
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900">
//                     ${parseFloat(selectedProduct.price).toFixed(2)}
//                   </p>
//                   <div className="mt-2 flex items-center gap-2">
//                     <span
//                       className={`px-2 py-1 rounded-full text-xs ${
//                         selectedProduct.quantity > 0
//                           ? "bg-green-100 text-green-800"
//                           : "bg-red-100 text-red-800"
//                       }`}
//                     >
//                       {selectedProduct.quantity} in stock
//                     </span>
//                     <span className="text-sm text-gray-600">
//                       {selectedProduct.perceived_colour_master_name} (
//                       {selectedProduct.perceived_colour_value_name})
//                     </span>
//                   </div>
//                   <p className="mt-2 text-sm text-gray-700">
//                     <span className="font-medium">Category:</span>{" "}
//                     {selectedProduct.section_name}
//                   </p>
//                 </div>
//               </div>

//               {/* Description */}
//               <div className="mb-6">
//                 <h3 className="font-semibold text-gray-900 mb-2">
//                   Description
//                 </h3>
//                 <p className="text-gray-700 whitespace-pre-line">
//                   {selectedProduct.enhanced_description ||
//                     selectedProduct.detail_desc ||
//                     "No description available."}
//                 </p>
//               </div>

//               {/* Edit & Enhance Actions */}
//               <div className="flex flex-wrap gap-3 mb-6">
//                 <button
//                   onClick={() => {
//                     setEditProductData({ ...selectedProduct });
//                     setIsEditingProduct(true);
//                   }}
//                   className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
//                 >
//                   Edit Product
//                 </button>
              
//               </div>

//               {/* Enhance Description */}
//               <div className="border-t pt-6">
//                 <h3 className="font-semibold text-gray-900 mb-3">
//                   Enhance Description (AI)
//                 </h3>
//                 <div className="space-y-3">
//                   <label className="block text-sm font-medium text-gray-700">
//                     Additional Prompt (Optional)
//                   </label>
//                   <textarea
//                     value={promptInput}
//                     onChange={(e) => setPromptInput(e.target.value)}
//                     placeholder="e.g., 'Make it sound luxurious and occasion-specific for weddings.'"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                     rows={3}
//                   />
//                   <button
//                     onClick={async () => {
//                       if (isEnriching) return;
//                       setIsEnriching(true);
//                       try {
//                         const res = await enrichProduct(
//                           selectedProduct.article_id,
//                           promptInput
//                         );
//                         if (res?.enriched_data?.enriched_description) {
//                           setEnrichedDescription(
//                             res.enriched_data.enriched_description
//                           );
//                         } else {
//                           throw new Error("No enriched description returned");
//                         }
//                       } catch (err) {
//                         alert(
//                           "Enrich failed: " +
//                             (err.message || "Unknown error")
//                         );
//                       } finally {
//                         setIsEnriching(false);
//                       }
//                     }}
//                     disabled={isEnriching}
//                     className={`px-4 py-2 rounded-lg font-medium ${
//                       isEnriching
//                         ? "bg-gray-400 text-white cursor-not-allowed"
//                         : "bg-blue-600 text-white hover:bg-blue-700"
//                     }`}
//                   >
//                     {isEnriching ? "Generating..." : "Regenerate Description"}
//                   </button>
//                 </div>
//               </div>

//               {/* Enriched Preview */}
//               {enrichedDescription && (
//                 <div className="mt-6 border-t pt-6">
//                   <h3 className="font-semibold text-gray-900 mb-2">
//                     Preview: Enhanced Description
//                   </h3>
//                   <div className="bg-gray-50 p-4 rounded-lg mb-4">
//                     <p className="text-gray-800 whitespace-pre-line">
//                       {enrichedDescription}
//                     </p>
//                   </div>
//                   <div className="flex gap-3">
//                     <button
//                       onClick={async () => {
//                         if (isUpdatingEnriched) return;
//                         setIsUpdatingEnriched(true);
//                         try {
//                           await updateEnrichedProduct(
//                             selectedProduct.article_id,
//                             enrichedDescription
//                           );
//                           const updatedProduct = {
//                             ...selectedProduct,
//                             enhanced_description: enrichedDescription,
//                           };
//                           setSelectedProduct(updatedProduct);
//                           setProducts((prev) =>
//                             prev.map((p) =>
//                               p.article_id === selectedProduct.article_id
//                                 ? updatedProduct
//                                 : p
//                             )
//                           );
//                           setEnrichedDescription("");
//                           setPromptInput("");
//                           alert("Enhanced description saved!");
//                         } catch (err) {
//                           alert(
//                             "Save failed: " +
//                               (err.message || "Unknown error")
//                           );
//                         } finally {
//                           setIsUpdatingEnriched(false);
//                         }
//                       }}
//                       disabled={isUpdatingEnriched}
//                       className={`px-4 py-2 rounded-lg font-medium ${
//                         isUpdatingEnriched
//                           ? "bg-green-400 text-white cursor-not-allowed"
//                           : "bg-green-600 text-white hover:bg-green-700"
//                       }`}
//                     >
//                       {isUpdatingEnriched ? "Saving..." : "Accept & Save"}
//                     </button>
//                     <button
//                       onClick={() => setEnrichedDescription("")}
//                       className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
//                     >
//                       Reject
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Product Modal */}
//       {isEditingProduct && editProductData && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//           <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold text-gray-900">
//                   Edit Product
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setIsEditingProduct(false);
//                     setEditProductData(null);
//                   }}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               {/* Structured Attribute Fields */}
//               <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2">
//                 {/* Core Fields */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     Article ID (Read-only)
//                   </label>
//                   <input
//                     value={editProductData.article_id}
//                     readOnly
//                     className="mt-1 block w-full px-3 py-2 bg-gray-100 border rounded-md text-sm"
//                   />
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Product Name
//                     </label>
//                     <input
//                       value={editProductData.prod_name || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           prod_name: e.target.value,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Enhanced Name
//                     </label>
//                     <input
//                       value={editProductData.enhanced_prod_name || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           enhanced_prod_name: e.target.value,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Price
//                     </label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       value={editProductData.price || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           price: parseFloat(e.target.value) || 0,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Discounted Price
//                     </label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       value={editProductData.discounted_price || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           discounted_price: parseFloat(e.target.value) || 0,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Stock Quantity
//                     </label>
//                     <input
//                       type="number"
//                       value={editProductData.quantity || 0}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           quantity: parseInt(e.target.value, 10) || 0,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Availability
//                     </label>
//                     <select
//                       value={editProductData.availability || "In Stock"}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           availability: e.target.value,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     >
//                       <option value="In Stock">In Stock</option>
//                       <option value="Out of Stock">Out of Stock</option>
//                       <option value="Pre-order">Pre-order</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     Detail Description
//                   </label>
//                   <textarea
//                     value={editProductData.detail_desc || ""}
//                     onChange={(e) =>
//                       setEditProductData({
//                         ...editProductData,
//                         detail_desc: e.target.value,
//                       })
//                     }
//                     rows={3}
//                     className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     Enhanced Description
//                   </label>
//                   <textarea
//                     value={editProductData.enhanced_description || ""}
//                     onChange={(e) =>
//                       setEditProductData({
//                         ...editProductData,
//                         enhanced_description: e.target.value,
//                       })
//                     }
//                     rows={4}
//                     className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                   />
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Color Name
//                     </label>
//                     <input
//                       value={editProductData.perceived_colour_master_name || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           perceived_colour_master_name: e.target.value,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       Section
//                     </label>
//                     <input
//                       value={editProductData.section_name || ""}
//                       onChange={(e) =>
//                         setEditProductData({
//                           ...editProductData,
//                           section_name: e.target.value,
//                         })
//                       }
//                       className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                     />
//                   </div>
//                 </div>

//                 {/* STRUCTURED ATTRIBUTES */}
//                 <div className="border-t pt-4">
//                   <h3 className="font-semibold text-gray-900 mb-3">
//                     Attributes
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {/* fit */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Fit
//                       </label>
//                       <input
//                         value={editProductData.attributes?.fit || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               fit: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Fitted, Loose, Regular"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* fabric */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Fabric
//                       </label>
//                       <input
//                         value={editProductData.attributes?.fabric || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               fabric: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Cotton, Jersey, Microfibre"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* style */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Style
//                       </label>
//                       <input
//                         value={editProductData.attributes?.style || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               style: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Camisole, T-shirt Bra, Strapless"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* neckline */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Neckline
//                       </label>
//                       <input
//                         value={editProductData.attributes?.neckline || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               neckline: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Scoop neck, Plunge, Round"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* sleeve_type */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Sleeve Type
//                       </label>
//                       <input
//                         value={editProductData.attributes?.sleeve_type || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               sleeve_type: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Sleeveless, Long Sleeve, Short Sleeve"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* length */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Length
//                       </label>
//                       <input
//                         value={editProductData.attributes?.length || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               length: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Regular, Mini, Maxi, N/A"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* pattern */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Pattern
//                       </label>
//                       <input
//                         value={editProductData.attributes?.pattern || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               pattern: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., Solid, Striped, Floral"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* season */}
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700">
//                         Season
//                       </label>
//                       <input
//                         value={editProductData.attributes?.season || ""}
//                         onChange={(e) =>
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               season: e.target.value,
//                             },
//                           })
//                         }
//                         placeholder="e.g., All, Summer, Winter, Spring"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                     </div>

//                     {/* occasions (comma-separated) */}
//                     <div className="md:col-span-2">
//                       <label className="block text-sm font-medium text-gray-700">
//                         Occasions (comma-separated)
//                       </label>
//                       <input
//                         value={
//                           Array.isArray(editProductData.attributes?.occasions)
//                             ? editProductData.attributes.occasions.join(", ")
//                             : ""
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const occasions = value
//                             .split(",")
//                             .map((s) => s.trim())
//                             .filter(Boolean);
//                           setEditProductData({
//                             ...editProductData,
//                             attributes: {
//                               ...editProductData.attributes,
//                               occasions,
//                             },
//                           });
//                         }}
//                         placeholder="e.g., casual, workwear, partywear"
//                         className="mt-1 block w-full px-3 py-2 border rounded-md text-sm"
//                       />
//                       <p className="mt-1 text-xs text-gray-500">
//                         Enter comma-separated values. Will be saved as array.
//                       </p>
//                     </div>
//                   </div>
//                 </div>

              
//               </div>

//               <div className="mt-6 flex justify-end gap-3">
//                 <button
//                   onClick={() => {
//                     setIsEditingProduct(false);
//                     setEditProductData(null);
//                   }}
//                   className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={async () => {
//                     if (!editProductData.article_id) return;
//                     if (!window.confirm("Save changes to this product?"))
//                       return;

//                     setIsUpdatingProduct(true);
//                     try {
//                       // Ensure attributes is always an object
//                       const attributes = editProductData.attributes || {};

//                       // Clean up empty strings
//                       Object.keys(attributes).forEach((key) => {
//                         if (
//                           typeof attributes[key] === "string" &&
//                           attributes[key].trim() === ""
//                         ) {
//                           delete attributes[key];
//                         }
//                       });

//                       const payload = {
//                         ...editProductData,
//                         attributes, // already an object
//                         size_list: Array.isArray(editProductData.size_list)
//                           ? editProductData.size_list
//                           : typeof editProductData.size_list === "string"
//                           ? editProductData.size_list
//                               .split(",")
//                               .map((s) => s.trim())
//                           : [],
//                       };

//                       const result = await updateProduct(payload);
//                       const updated = result.updated_article;

//                       // Update local state
//                       const updatedList = products.map((p) =>
//                         p.article_id === updated.article_id ? updated : p
//                       );
//                       setProducts(updatedList);

//                       if (selectedProduct?.article_id === updated.article_id) {
//                         setSelectedProduct(updated);
//                       }

//                       alert("Product updated!");
//                       setIsEditingProduct(false);
//                       setEditProductData(null);
//                     } catch (err) {
//                       alert(
//                         "Save failed: " + (err.message || "Unknown error")
//                       );
//                     } finally {
//                       setIsUpdatingProduct(false);
//                     }
//                   }}
//                   disabled={isUpdatingProduct}
//                   className={`px-4 py-2 rounded-lg font-medium ${
//                     isUpdatingProduct
//                       ? "bg-blue-400 text-white cursor-not-allowed"
//                       : "bg-blue-600 text-white hover:bg-blue-700"
//                   }`}
//                 >
//                   {isUpdatingProduct ? "Saving..." : "Save Changes"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminPage




import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { isAdmin } from "../utils/auth";
import { useAuth } from "../context/AuthContext";
import { signOut } from "../utils/auth";
import EditUserModal from "../components/EditUserModal";
import CreateUserModal from "./CreateUserModal";

// Import all APIs (ensure `updateProduct`, `enrichProduct`, `updateEnrichedProduct` are added in `adminApi.js`)
import {
  updateUserPreferences,
  deleteUser,
  createUser,
  fetchProducts,
  updateProduct,
  enrichProduct,
  searchProducts,
} from "../api/adminApi";

// Safely parse attributes (handles null, string, or object)
const parseAttributes = (rawAttrs) => {
  if (!rawAttrs) return {};

  // Case 1: already an object → return as-is
  if (typeof rawAttrs === "object" && !Array.isArray(rawAttrs)) {
    return rawAttrs;
  }

  // Case 2: string → try to parse (possibly multiple times)
  if (typeof rawAttrs === "string") {
    let str = rawAttrs.trim();

    // Normalize: unescape *repeatedly* until it's valid JSON or no change
    let last;
    do {
      last = str;
      try {
        // Try parsing. If success, return result.
        const parsed = JSON.parse(str);
        // If result is string, keep unescaping
        if (typeof parsed === "string") {
          str = parsed;
        } else {
          return parsed; // success: object/array
        }
      } catch (e) {
        // Not valid JSON — assume it's escaped JSON string → unescape quotes
        // Remove surrounding quotes if present: "..." → ...
        if (str.startsWith('"') && str.endsWith('"')) {
          str = str.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        } else {
          // Give up
          console.warn("Unable to parse attributes:", rawAttrs);
          return {};
        }
      }
    } while (str !== last);

    // Final try
    try {
      return JSON.parse(str);
    } catch (e) {
      console.warn("Final parse failed for attributes:", rawAttrs);
    }
  }

  return {};
};

const AdminPage = () => {
const navigate = useNavigate();
const { user, login } = useAuth();
const users = user?.users || [];

// Tab & product state
const [activeTab, setActiveTab] = useState("users");
const [editingUser, setEditingUser] = useState(null);
const [isCreating, setIsCreating] = useState(false);

// Sign out modal state
const [showSignOutModal, setShowSignOutModal] = useState(false);
const [isSigningOut, setIsSigningOut] = useState(false);

// Product management (updated)
const [products, setProducts] = useState([]);
const [loadingProducts, setLoadingProducts] = useState(false);
const [pagination, setPagination] = useState({
  currentPage: 1,
  pageSize: 50,
  totalPages: 1,
  totalRecords: 0,
});

// Product detail modal (unchanged)
const [selectedProduct, setSelectedProduct] = useState(null);
const [promptInput, setPromptInput] = useState("");
const [enrichedDescription, setEnrichedDescription] = useState("");
const [isEnriching, setIsEnriching] = useState(false);
const [enrichedAttributes, setEnrichedAttributes] = useState({});
const [isUpdatingProduct, setIsUpdatingProduct] = useState(false);
const [useEnrichedDescription, setUseEnrichedDescription] = useState(false);
const [isDescriptionDiscarded, setIsDescriptionDiscarded] = useState(false);
const [acceptedAttributes, setAcceptedAttributes] = useState({});

// Search and filter state for users (unchanged)
const [userSearchTerm, setUserSearchTerm] = useState("");
const [userFilters, setUserFilters] = useState({
  name: "",
  email: "",
  apparel: "",
  size: "",
  color: "",
  tone: "",
});

// ✅ NEW: Search state for products (replaces old filters & term)
const [searchParams, setSearchParams] = useState({
  article_id: "",
  product_name: "", // maps to prod_name/enhanced_prod_name in API
  color: "",
  category: "",
  min_price: "",
  max_price: "",
});
const [isSearching, setIsSearching] = useState(false);

// Redirect non-admins
useEffect(() => {
  if (!isAdmin()) {
    navigate("/", { replace: true });
  }
}, [navigate]);

// Load products (default pagination)
const loadProducts = useCallback(async (page = 1, size = 50) => {
  setLoadingProducts(true);
  setIsSearching(false);
  try {
    const data = await fetchProducts(page, size);
    setProducts(data.products);
    setPagination({
      currentPage: data.currentPage,
      pageSize: data.pageSize,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    });
  } catch (error) {
    console.error("Failed to load products", error);
    alert("Failed to load products: " + (error.message || "Unknown error"));
  } finally {
    setLoadingProducts(false);
  }
}, []);

// ✅ NEW: Search products via API (only sends non-empty fields)
const handleSearch = useCallback(async (page = 1, size = 50) => {
  // Build clean filters object (omit blank fields)
  const filters = {};
  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== "" && value != null) {
      filters[key] = value;
    }
  });

  // If no filters → fallback to default load
  if (Object.keys(filters).length === 0) {
    return loadProducts(page, size);
  }

  setLoadingProducts(true);
  setIsSearching(true);
  try {
    // ✅ Call new search API
    const data = await searchProducts(filters, page, size);
    setProducts(data.products);
    setPagination({
      currentPage: data.currentPage,
      pageSize: data.pageSize,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    });
  } catch (error) {
    console.error("Search failed", error);
    alert("Search failed: " + (error.message || "Unknown error"));
    // Fallback to default on error
    loadProducts(page, size);
  } finally {
    setLoadingProducts(false);
  }
}, [searchParams, loadProducts]);

// Initial load
useEffect(() => {
  if (activeTab === "products") {
    const hasSearchParams = Object.values(searchParams).some(v => v);
    if (hasSearchParams) {
      handleSearch(1, pagination.pageSize);
    } else {
      loadProducts(1, pagination.pageSize);
    }
  }
}, [activeTab, loadProducts, handleSearch, searchParams, pagination.pageSize]);

// Pagination — works for both default and search
const goToPage = (page) => {
  if (page < 1 || page > pagination.totalPages) return;
  const hasSearchParams = Object.values(searchParams).some(v => v);
  if (hasSearchParams) {
    handleSearch(page, pagination.pageSize);
  } else {
    loadProducts(page, pagination.pageSize);
  }
};
const nextPage = () => goToPage(pagination.currentPage + 1);
const prevPage = () => goToPage(pagination.currentPage - 1);

// ✅ Clear search
const clearSearch = () => {
  setSearchParams({
    article_id: "",
    product_name: "",
    color: "",
    category: "",
    min_price: "",
    max_price: "",
  });
};

const handleSignOut = () => {
  // Show confirmation modal
  setShowSignOutModal(true);
};

const handleConfirmSignOut = async () => {
  setIsSigningOut(true);
  try {
    // Call logout API and clear local data
    await signOut(false, null); // Don't show alert, we'll handle it ourselves
    
    // Redirect to landing page on success
    navigate("/");
  } catch (error) {
    console.error("Sign out error:", error);
    // Even on error, redirect to landing page
    navigate("/");
  } finally {
    setIsSigningOut(false);
    setShowSignOutModal(false);
  }
};

const handleCancelSignOut = () => {
  setShowSignOutModal(false);
};

// Save user (unchanged)
const handleSaveUser = async (updatedData) => {
  try {
    await updateUserPreferences(updatedData);
    const updatedUsers = users.map((u) =>
      u.user.customer_id === updatedData.customer_id
        ? {
            ...u,
            user: {
              ...u.user,
              email: updatedData.email,
              age: updatedData.age,
              first_name: updatedData.first_name,
              last_name: updatedData.last_name,
            },
            preferences: {
              ...u.preferences,
              ...updatedData,
            },
          }
        : u
    );
    login({ ...user, users: updatedUsers });
    setEditingUser(null);
  } catch (err) {
    alert("Failed to update user: " + (err.message || "Unknown error"));
  }
};

// Delete user (unchanged)
const handleDeleteUser = async (customer_id, email) => {
  if (!window.confirm(`Delete user ${email}?`)) return;
  try {
    await deleteUser(customer_id);
    const updatedUsers = users.filter((u) => u.user.customer_id !== customer_id);
    login({ ...user, users: updatedUsers });
    alert("User deleted successfully.");
  } catch (error) {
    alert("Delete failed: " + (error.message || "Unknown error"));
  }
};

// ➕ Create user (unchanged)
const handleCreateUser = async (userData) => {
  try {
    const newUser = await createUser(userData);
    const newUserItem = {
      user: {
        ...userData.user,
        customer_id: newUser.customer_id,
        id: Date.now(),
        user_role: "C",
      },
      preferences: userData.preferences,
    };
    login({ ...user, users: [...users, newUserItem] });
    alert("User created successfully!");
    setIsCreating(false);
  } catch (error) {
    alert("Create failed: " + (error.message || "Unknown error"));
  }
};

// Filter users (unchanged)
const getFilteredUsers = () => {
  return users.filter((userItem) => {
    const { user: u, preferences } = userItem;

    if (userSearchTerm) {
      const searchLower = userSearchTerm.toLowerCase();
      const matchesSearch =
        (u.first_name?.toLowerCase().includes(searchLower) || false) ||
        (u.last_name?.toLowerCase().includes(searchLower) || false) ||
        (u.username?.toLowerCase().includes(searchLower) || false) ||
        (u.email?.toLowerCase().includes(searchLower) || false);
      if (!matchesSearch) return false;
    }

    if (userFilters.name) {
      const nameLower = userFilters.name.toLowerCase();
      const fullName = `${u.first_name || ""} ${u.last_name || ""}`.toLowerCase();
      const username = (u.username || "").toLowerCase();
      if (!fullName.includes(nameLower) && !username.includes(nameLower)) return false;
    }

    if (userFilters.email && !u.email?.toLowerCase().includes(userFilters.email.toLowerCase())) {
      return false;
    }

    if (userFilters.apparel && preferences.apparel_preference?.toLowerCase() !== userFilters.apparel.toLowerCase()) {
      return false;
    }

    if (userFilters.size && preferences.clothing_size?.toLowerCase() !== userFilters.size.toLowerCase()) {
      return false;
    }

    if (userFilters.color && preferences.color_preference?.toLowerCase() !== userFilters.color.toLowerCase()) {
      return false;
    }

    if (userFilters.tone && preferences.color_tone_preference?.toLowerCase() !== userFilters.tone.toLowerCase()) {
      return false;
    }

    return true;
  });
};

// Get unique values for user filters (unchanged)
const getUniqueUserValues = (field) => {
  const values = new Set();
  users.forEach((userItem) => {
    if (field === "apparel") {
      values.add(userItem.preferences.apparel_preference || "");
    } else if (field === "size") {
      values.add(userItem.preferences.clothing_size || "");
    } else if (field === "color") {
      values.add(userItem.preferences.color_preference || "");
    } else if (field === "tone") {
      values.add(userItem.preferences.color_tone_preference || "");
    }
  });
  return Array.from(values).filter(Boolean).sort();
};

if (!isAdmin()) return null;
  return (
    <>
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      {/* Tabs */}
    <div className="flex flex-wrap items-center gap-2 mb-6 border-b">
  {/* Tabs */}
  <button
    onClick={() => setActiveTab("users")}
    className={`px-4 py-2 font-medium rounded-t-lg ${
      activeTab === "users"
        ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
        : "text-gray-500 hover:text-gray-700"
    }`}
  >
    User Management
  </button>
  <button
    onClick={() => setActiveTab("products")}
    className={`px-4 py-2 font-medium rounded-t-lg ${
      activeTab === "products"
        ? "bg-white text-blue-600 border-t border-l border-r border-gray-200"
        : "text-gray-500 hover:text-gray-700"
    }`}
  >
    Product Management
  </button>

  {/* Right-aligned Sign Out button */}
  <button
    onClick={handleSignOut}
    className="ml-auto px-3 py-2 text-sm font-medium text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition self-center"
    aria-label="Sign out"
  >
     Sign out
  </button>
</div>

      {/* 👤 Users Tab */}
      {activeTab === "users" && (
        <>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                User Management
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                Showing <span className="font-semibold">{getFilteredUsers().length}</span> of{" "}
                <span className="font-semibold">{users.length}</span> users
              </p>
            </div>
            <button
              onClick={() => setIsCreating(true)}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
            >
              + Create User
            </button>
          </div>

          {/* Search Bar */}
          <div className="mb-4">
            <div className="flex gap-2">
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Search users by name, username, or email..."
                  value={userSearchTerm}
                  onChange={(e) => setUserSearchTerm(e.target.value)}
                  className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <svg
                  className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              {(userSearchTerm || Object.values(userFilters).some(v => v)) && (
                <button
                  onClick={() => {
                    setUserSearchTerm("");
                    setUserFilters({ name: "", email: "", apparel: "", size: "", color: "", tone: "" });
                  }}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition"
                >
                  Clear Filters
                </button>
              )}
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <div className="space-y-2">
                        <div>User</div>
                        <input
                          type="text"
                          placeholder="Filter..."
                          value={userFilters.name}
                          onChange={(e) => setUserFilters({ ...userFilters, name: e.target.value })}
                          className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <div className="space-y-2">
                        <div>Email</div>
                        <input
                          type="text"
                          placeholder="Filter..."
                          value={userFilters.email}
                          onChange={(e) => setUserFilters({ ...userFilters, email: e.target.value })}
                          className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <div className="space-y-2">
                        <div>Preferences</div>
                        <div className="grid grid-cols-2 gap-1">
                          <select
                            value={userFilters.apparel}
                            onChange={(e) => setUserFilters({ ...userFilters, apparel: e.target.value })}
                            className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <option value="">All Apparel</option>
                            {getUniqueUserValues("apparel").map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </select>
                          <select
                            value={userFilters.size}
                            onChange={(e) => setUserFilters({ ...userFilters, size: e.target.value })}
                            className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <option value="">All Sizes</option>
                            {getUniqueUserValues("size").map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </select>
                          <select
                            value={userFilters.color}
                            onChange={(e) => setUserFilters({ ...userFilters, color: e.target.value })}
                            className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <option value="">All Colors</option>
                            {getUniqueUserValues("color").map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </select>
                          <select
                            value={userFilters.tone}
                            onChange={(e) => setUserFilters({ ...userFilters, tone: e.target.value })}
                            className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <option value="">All Tones</option>
                            {getUniqueUserValues("tone").map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {getFilteredUsers().length > 0 ? (
                    getFilteredUsers().map((userItem) => {
                      const { user: u, preferences } = userItem;
                      return (
                        <tr
                          key={u.id || u.customer_id}
                          className="hover:bg-gray-50"
                        >
                          <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {u.first_name} {u.last_name}
                            </div>
                            <div className="text-sm text-gray-500">
                              @{u.username}
                            </div>
                          </td>
                          <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {u.email}
                          </td>
                          <td className="px-4 sm:px-6 py-4 text-sm text-gray-700">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
                              <div>
                                <span className="font-medium">Apparel:</span>{" "}
                                {preferences.apparel_preference}
                              </div>
                              <div>
                                <span className="font-medium">Size:</span>{" "}
                                {preferences.clothing_size}
                              </div>
                              <div>
                                <span className="font-medium">Color:</span>{" "}
                                {preferences.color_preference}
                              </div>
                              <div>
                                <span className="font-medium">Tone:</span>{" "}
                                {preferences.color_tone_preference}
                              </div>
                            </div>
                          </td>
                          <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm space-x-3">
                            <button
                              onClick={() =>
                                setEditingUser({ user: u, preferences })
                              }
                              className="text-blue-600 hover:text-blue-800 p-1"
                              aria-label="Edit user"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                              </svg>
                            </button>
                            <button
                              onClick={() =>
                                handleDeleteUser(u.customer_id, u.email)
                              }
                              className="text-red-600 hover:text-red-800 p-1"
                              aria-label="Delete user"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="px-6 py-8 text-center text-gray-500"
                      >
                        {users.length === 0 ? "No users found." : "No users match your search/filters."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

  {activeTab === "products" && (
        <>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                Product Management
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                {isSearching ? (
                  <>
                    Showing <span className="font-semibold">{products.length}</span> of{" "}
                    <span className="font-semibold">{pagination.totalRecords}</span> results
                  </>
                ) : (
                  <>
                    Showing <span className="font-semibold">{products.length}</span> of{" "}
                    <span className="font-semibold">{pagination.totalRecords}</span> products
                  </>
                )}
              </p>
            </div>
          </div>

          {/* ✅ NEW: Dedicated Search Inputs — one per field */}
          <div className="mb-6 p-4 bg-white rounded-xl shadow-sm border border-gray-200">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Search Products</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
              {/* Article ID */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Article ID</label>
                <input
                  type="text"
                  value={searchParams.article_id}
                  onChange={(e) => setSearchParams({ ...searchParams, article_id: e.target.value })}
                  placeholder="e.g. 0108775015"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Product Name */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Product Name</label>
                <input
                  type="text"
                  value={searchParams.product_name}
                  onChange={(e) => setSearchParams({ ...searchParams, product_name: e.target.value })}
                  placeholder="e.g. Strap top"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Color */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Color</label>
                <input
                  type="text"
                  value={searchParams.color}
                  onChange={(e) => setSearchParams({ ...searchParams, color: e.target.value })}
                  placeholder="e.g. Black"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Category */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Category</label>
                <input
                  type="text"
                  value={searchParams.category}
                  onChange={(e) => setSearchParams({ ...searchParams, category: e.target.value })}
                  placeholder="e.g. Womens Everyday Basics"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Min Price */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Min Price ($)</label>
                <input
                  type="number"
                  step="0.01"
                  value={searchParams.min_price}
                  onChange={(e) => setSearchParams({ ...searchParams, min_price: e.target.value })}
                  placeholder="e.g. 10.00"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Max Price */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Max Price ($)</label>
                <input
                  type="number"
                  step="0.01"
                  value={searchParams.max_price}
                  onChange={(e) => setSearchParams({ ...searchParams, max_price: e.target.value })}
                  placeholder="e.g. 20.00"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="mt-4 flex gap-3">
              <button
                onClick={() => handleSearch(1, pagination.pageSize)}
                disabled={loadingProducts}
                className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 transition"
              >
                {loadingProducts ? "Searching..." : "Search"}
              </button>
              {(searchParams.article_id || searchParams.product_name || searchParams.color || searchParams.category || searchParams.min_price || searchParams.max_price) && (
                <button
                  onClick={clearSearch}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Clear
                </button>
              )}
            </div>
          </div>

          {/* Loading / No Products / Table */}
          {loadingProducts ? (
            <div className="flex justify-center py-12">
              <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : products.length === 0 ? (
            <p className="text-gray-500 text-center py-10">
              {isSearching ? "No products match your search." : "No products found."}
            </p>
          ) : (
            <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      {/* ✅ Simplified headers — no in-table filters */}
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Article ID
                      </th>
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Price
                      </th>
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Stock
                      </th>
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Color
                      </th>
                      <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Category
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {products.map((p) => (
                      <tr
                        key={p.article_id}
                        className="hover:bg-gray-50 cursor-pointer"
                        onClick={() => setSelectedProduct(p)}
                      >
                        <td className="px-4 sm:px-6 py-3 text-sm font-mono text-gray-700">
                          {p.article_id}
                        </td>
                        <td className="px-4 sm:px-6 py-3 text-sm font-medium text-gray-900">
                          {p.enhanced_prod_name || p.prod_name}
                        </td>
                        <td className="px-4 sm:px-6 py-3 text-sm text-gray-900">
                          ${parseFloat(p.price).toFixed(2)}
                        </td>
                        <td className="px-4 sm:px-6 py-3 text-sm">
                          <span
                            className={`px-2 py-1 rounded-full text-xs ${
                              p.quantity > 0
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                          >
                            {p.quantity} in stock
                          </span>
                        </td>
                        <td className="px-4 sm:px-6 py-3 text-sm text-gray-700">
                          {p.perceived_colour_master_name} (
                          {p.perceived_colour_value_name})
                        </td>
                        <td className="px-4 sm:px-6 py-3 text-sm text-gray-600 truncate max-w-xs">
                          {p.section_name}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination — unchanged */}
              <div className="px-4 py-3 bg-gray-50 flex items-center justify-between border-t border-gray-200">
                <div className="text-sm text-gray-700">
                  Showing{" "}
                  <span className="font-medium">
                    {(pagination.currentPage - 1) * pagination.pageSize + 1}
                  </span>{" "}
                  to{" "}
                  <span className="font-medium">
                    {Math.min(pagination.currentPage * pagination.pageSize, pagination.totalRecords)}
                  </span>{" "}
                  of{" "}
                  <span className="font-medium">{pagination.totalRecords}</span> results
                </div>
                <div className="flex flex-wrap gap-1 sm:gap-2">
                  <button
                    onClick={prevPage}
                    disabled={pagination.currentPage <= 1}
                    className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                  >
                    Prev
                  </button>
                  {[...Array(Math.min(5, pagination.totalPages))].map((_, i) => {
                    const pageNum = i + 1;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => goToPage(pageNum)}
                        className={`px-3 py-1 rounded-md text-sm font-medium ${
                          pageNum === pagination.currentPage
                            ? "bg-blue-600 text-white"
                            : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                  <button
                    onClick={nextPage}
                    disabled={pagination.currentPage >= pagination.totalPages}
                    className="px-3 py-1 rounded-md bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* MODALS */}

      {editingUser && (
        <EditUserModal
          user={editingUser.user}
          preferences={editingUser.preferences}
          onClose={() => setEditingUser(null)}
          onSave={handleSaveUser}
        />
      )}

      {isCreating && (
        <CreateUserModal
          onClose={() => setIsCreating(false)}
          onCreate={handleCreateUser}
        />
      )}
{selectedProduct && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200 flex justify-between items-start">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            {selectedProduct.enhanced_prod_name || selectedProduct.prod_name}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Article ID: <span className="font-mono font-bold">{selectedProduct.article_id}</span> {/* read-only */}
          </p>
        </div>
        <button
          onClick={() => {
            setSelectedProduct(null);
            setPromptInput("");
            setEnrichedDescription("");
            setEnrichedAttributes({});
            setUseEnrichedDescription(false);
            setIsDescriptionDiscarded(false);
            setAcceptedAttributes({});
          }}
          className="text-gray-400 hover:text-gray-600 p-2 rounded-full hover:bg-gray-100 transition"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6 space-y-6 max-h-[70vh]">
        {/* Image and Key Fields Side by Side */}
        <div className="flex flex-col md:flex-row gap-6">
          {/* Image on Left */}
          <div className="flex-shrink-0">
            <img
              src={
                selectedProduct.image_url?.trim() ||
                "https://via.placeholder.com/400x500?text=No+Image"
              }
              alt={selectedProduct.prod_name}
              className="w-full md:w-80 h-80 object-contain bg-gray-50 rounded-xl shadow-sm"
              onError={(e) =>
                (e.currentTarget.src = "https://via.placeholder.com/400x500?text=Image+Error")
              }
            />
          </div>

          {/* Key Fields on Right */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
              <input
                type="text"
                value={selectedProduct.prod_name || ""}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, prod_name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Enhanced Name</label>
              <input
                type="text"
                value={selectedProduct.enhanced_prod_name || ""}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, enhanced_prod_name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Price ($)</label>
              <input
                type="number"
                step="0.01"
                value={selectedProduct.price || ""}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, price: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Discounted Price ($)</label>
              <input
                type="number"
                step="0.01"
                value={selectedProduct.discounted_price || ""}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, discounted_price: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Stock Quantity</label>
              <input
                type="number"
                value={selectedProduct.quantity || 0}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, quantity: parseInt(e.target.value) || 0 })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Availability</label>
              <select
                value={selectedProduct.availability || "In Stock"}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, availability: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              >
                <option value="In Stock">In Stock</option>
                <option value="Out of Stock">Out of Stock</option>
                <option value="Pre-order">Pre-order</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">On Sale</label>
              <select
                value={selectedProduct.on_sale || "No"}
                onChange={(e) => setSelectedProduct({ ...selectedProduct, on_sale: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Size List (comma-separated)</label>
              <input
                type="text"
                value={
                  Array.isArray(selectedProduct.size_list)
                    ? selectedProduct.size_list.join(", ")
                    : (selectedProduct.size_list?.replace(/[[\]"]/g, "") || "")
                }
                onChange={(e) => {
                  const val = e.target.value;
                  // Store as array for clean API send later
                  const arr = val
                    .split(",")
                    .map(s => s.trim())
                    .filter(Boolean);
                  setSelectedProduct({
                    ...selectedProduct,
                    size_list: arr
                  });
                }}
                placeholder="e.g., XS, S, M, L"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        {/* Additional Editable Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Row 5 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Section</label>
            <input
              type="text"
              value={selectedProduct.section_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, section_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
            <input
              type="text"
              value={selectedProduct.department_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, department_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>

          {/* Row 6 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Garment Group</label>
            <input
              type="text"
              value={selectedProduct.garment_group_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, garment_group_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Product Group</label>
            <input
              type="text"
              value={selectedProduct.product_group_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, product_group_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>

          {/* Row 7 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Product Type</label>
            <input
              type="text"
              value={selectedProduct.product_type_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, product_type_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Index / Category</label>
            <input
              type="text"
              value={selectedProduct.index_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, index_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>

          {/* Row 8 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Colour Group</label>
            <input
              type="text"
              value={selectedProduct.colour_group_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, colour_group_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Perceived Colour</label>
            <input
              type="text"
              value={selectedProduct.perceived_colour_master_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, perceived_colour_master_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>

          {/* Row 9 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Colour Tone</label>
            <input
              type="text"
              value={selectedProduct.perceived_colour_value_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, perceived_colour_value_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Graphical Appearance</label>
            <input
              type="text"
              value={selectedProduct.graphical_appearance_name || ""}
              onChange={(e) => setSelectedProduct({ ...selectedProduct, graphical_appearance_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* --- EDITABLE SECTIONS --- */}

        {/* Enhanced Description (Editable) */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">Enhanced Description</h3>
          <textarea
            value={selectedProduct.enhanced_description || ""}
            onChange={(e) => setSelectedProduct({ ...selectedProduct, enhanced_description: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            rows={6}
            placeholder="Enter enhanced description..."
          />
        </div>

        {/* Attributes (Editable) */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">Attributes</h3>
          {(() => {
            const parsed = parseAttributes(selectedProduct.attributes);
            return (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  "fit",
                  "style",
                  "fabric",
                  "length",
                  "season",
                  "pattern",
                  "neckline",
                  "occasions",
                  "sleeve_type"
                ].map((key) => {
                  const value = parsed[key];
                  const displayValue = value == null 
                    ? "" 
                    : Array.isArray(value) 
                      ? value.join(", ") 
                      : String(value).trim() === "" 
                        ? "" 
                        : String(value);
                  return (
                    <div key={key}>
                      <label className="block text-sm font-medium text-gray-700 mb-1 capitalize">
                        {key.replace(/_/g, " ")}
                      </label>
                      {key === "occasions" ? (
                        <input
                          type="text"
                          value={displayValue}
                          onChange={(e) => {
                            const val = e.target.value;
                            const occasions = val
                              .split(",")
                              .map((s) => s.trim())
                              .filter(Boolean);
                            const updatedAttributes = {
                              ...parsed,
                              occasions: occasions.length > 0 ? occasions : undefined,
                            };
                            // Clean up undefined values
                            Object.keys(updatedAttributes).forEach((k) => {
                              if (updatedAttributes[k] === undefined) {
                                delete updatedAttributes[k];
                              }
                            });
                            setSelectedProduct({
                              ...selectedProduct,
                              attributes: updatedAttributes,
                            });
                          }}
                          placeholder="e.g., casual, workwear, partywear"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                      ) : (
                        <input
                          type="text"
                          value={displayValue}
                          onChange={(e) => {
                            const updatedAttributes = {
                              ...parsed,
                              [key]: e.target.value.trim() || undefined,
                            };
                            // Clean up undefined values
                            Object.keys(updatedAttributes).forEach((k) => {
                              if (updatedAttributes[k] === undefined || updatedAttributes[k] === "") {
                                delete updatedAttributes[k];
                              }
                            });
                            setSelectedProduct({
                              ...selectedProduct,
                              attributes: updatedAttributes,
                            });
                          }}
                          placeholder={`Enter ${key.replace(/_/g, " ")}...`}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>

        {/* AI Enrichment — Unchanged (Accept/Reject preserved) */}
        <div className="border-t border-gray-200 pt-6">
          <h3 className="font-bold text-lg text-gray-900 mb-4 flex items-center gap-2">
Enhance Content
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Prompt (Optional)
              </label>
              <textarea
                value={promptInput}
                onChange={(e) => setPromptInput(e.target.value)}
                placeholder="e.g., Make it luxurious and occasion-specific for weddings..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                rows={2}
              />
            </div>
            <div className="flex gap-3">
              <button
                onClick={async () => {
                  if (isEnriching) return;
                  setIsEnriching(true);
                  try {
                    const res = await enrichProduct(selectedProduct.article_id, promptInput);
                    if (res?.enriched_data) {
                      const { enriched_description, attributes } = res.enriched_data;
                      setEnrichedDescription(enriched_description || "");
                      setEnrichedAttributes(attributes && typeof attributes === "object" ? attributes : {});
                      setUseEnrichedDescription(false);
                      setIsDescriptionDiscarded(false);
                      setAcceptedAttributes({});
                    } else {
                      throw new Error("No enriched_data returned");
                    }
                  } catch (err) {
                    alert("Enrich failed: " + (err.message || "Unknown error"));
                  } finally {
                    setIsEnriching(false);
                  }
                }}
                disabled={isEnriching}
                className={`px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 ${
                  isEnriching
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-indigo-600 text-white hover:bg-indigo-700 shadow"
                }`}
              >
                {isEnriching ? (
                  <>
                    <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Generating...
                  </>
                ) : (
                  "Regenerate Description & Attributes"
                )}
              </button>
            </div>
          </div>

          {(enrichedDescription || Object.keys(enrichedAttributes).length > 0) && (
            <div className="mt-6 bg-indigo-50 border border-indigo-200 rounded-xl overflow-hidden">
              <div className="bg-indigo-100 px-4 py-2 flex items-center justify-between">
                <h4 className="font-medium text-indigo-800">Preview: Suggested Content</h4>
                <div className="text-xs bg-indigo-200 text-indigo-800 px-2 py-0.5 rounded">
                  Not saved yet
                </div>
              </div>
              <div className="p-5 space-y-5">
                {enrichedDescription && (
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <h5 className="font-medium text-gray-800">Generated Description</h5>
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            setUseEnrichedDescription(true);
                            setIsDescriptionDiscarded(false);
                          }}
                          className={`text-xs px-2 py-1 rounded ${
                            useEnrichedDescription ? "bg-green-100 text-green-800" : "bg-gray-200 text-gray-700 hover:bg-green-50"
                          }`}
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => {
                            setUseEnrichedDescription(false);
                            setIsDescriptionDiscarded(true);
                          }}
                          className={`text-xs px-2 py-1 rounded ${
                            isDescriptionDiscarded ? "bg-red-100 text-red-800" : "bg-gray-200 text-gray-700 hover:bg-red-50"
                          }`}
                        >
                          Discard
                        </button>
                      </div>
                    </div>
                    <div
                      className={`p-4 rounded-lg border whitespace-pre-line ${
                        useEnrichedDescription ? "bg-green-50 border-green-200" : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      {enrichedDescription}
                    </div>
                  </div>
                )}

                {Object.keys(enrichedAttributes).length > 0 && (() => {
                  // Check if all attributes are accepted
                  const allKeys = Object.keys(enrichedAttributes);
                  const allAccepted = allKeys.length > 0 && allKeys.every(key => acceptedAttributes[key] === true);
                  // Check if all attributes are discarded
                  const allDiscarded = allKeys.length > 0 && allKeys.every(key => acceptedAttributes[key] === false);
                  
                  return (
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <h5 className="font-medium text-gray-800">Suggested Attributes</h5>
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              const all = {};
                              Object.keys(enrichedAttributes).forEach((k) => (all[k] = true));
                              setAcceptedAttributes(all);
                            }}
                            className={`text-xs px-2 py-1 rounded transition-colors ${
                              allAccepted
                                ? "bg-green-200 text-green-900 hover:bg-green-300"
                                : "bg-gray-300 text-gray-600 hover:bg-gray-400"
                            }`}
                          >
                            Accept All
                          </button>
                          <button
                            onClick={() => {
                              // Mark all attributes as rejected
                              const all = {};
                              Object.keys(enrichedAttributes).forEach((k) => (all[k] = false));
                              setAcceptedAttributes(all);
                            }}
                            className={`text-xs px-2 py-1 rounded transition-colors ${
                              allDiscarded
                                ? "bg-red-200 text-red-900 hover:bg-red-300"
                                : "bg-gray-300 text-gray-600 hover:bg-gray-400"
                            }`}
                          >
                            Discard All
                          </button>
                        </div>
                      </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {Object.entries(enrichedAttributes).map(([key, value]) => {
                        const isAccepted = acceptedAttributes[key] === true;
                        const isRejected = acceptedAttributes[key] === false;
                        return (
                          <div key={key} className="flex flex-col bg-white p-3 rounded-lg border">
                            <div className="flex justify-between items-start">
                              <span className="text-sm font-medium text-gray-600 capitalize">
                                {key.replace(/_/g, " ")}
                              </span>
                              <div className="flex gap-1">
                                <button
                                  onClick={() => {
                                    if (isAccepted) {
                                      // If already accepted, remove the acceptance
                                      setAcceptedAttributes((prev) => {
                                        const updated = { ...prev };
                                        delete updated[key];
                                        return updated;
                                      });
                                    } else {
                                      // Accept it
                                      setAcceptedAttributes((prev) => ({ ...prev, [key]: true }));
                                    }
                                  }}
                                  className={`text-xs px-1.5 py-0.5 rounded transition-colors ${
                                    isAccepted
                                      ? "bg-green-200 text-green-900 hover:bg-green-300"
                                      : "bg-gray-300 text-gray-600 hover:bg-gray-400"
                                  }`}
                                  title={isAccepted ? "Remove acceptance" : "Accept"}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => {
                                    if (isRejected) {
                                      // If already rejected, remove the rejection
                                      setAcceptedAttributes((prev) => {
                                        const updated = { ...prev };
                                        delete updated[key];
                                        return updated;
                                      });
                                    } else {
                                      // Reject it
                                      setAcceptedAttributes((prev) => ({ ...prev, [key]: false }));
                                    }
                                  }}
                                  className={`text-xs px-1.5 py-0.5 rounded transition-colors ${
                                    isRejected
                                      ? "bg-red-200 text-red-900 hover:bg-red-300"
                                      : "bg-gray-300 text-gray-600 hover:bg-gray-400"
                                  }`}
                                  title={isRejected ? "Remove rejection" : "Reject"}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <span className="text-sm text-gray-900 mt-1 max-w-full break-words">
                              {Array.isArray(value) ? value.join(", ") : String(value)}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          )}
        </div>

        {/* Save Button */}
        <div className="pt-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={() => {
              setSelectedProduct(null);
              setPromptInput("");
              setEnrichedDescription("");
              setEnrichedAttributes({});
              setUseEnrichedDescription(false);
              setIsDescriptionDiscarded(false);
              setAcceptedAttributes({});
            }}
            className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium"
          >
            Cancel
          </button>
          <button
            onClick={async () => {
              if (isUpdatingProduct) return;
              
              // Check if there are pending suggestions that haven't been accepted or discarded
              const hasPendingDescription = enrichedDescription && !useEnrichedDescription && !isDescriptionDiscarded;
              const hasPendingAttributes = Object.keys(enrichedAttributes).length > 0 && 
                Object.keys(enrichedAttributes).some(key => acceptedAttributes[key] === undefined);
              
              if (hasPendingDescription || hasPendingAttributes) {
                const messages = [];
                if (hasPendingDescription) {
                  messages.push("enhanced description");
                }
                if (hasPendingAttributes) {
                  messages.push("attributes");
                }
                alert(`You have pending AI-generated suggestions for ${messages.join(" and ")}. Please accept or discard them before saving.`);
                return;
              }
              
              if (!window.confirm(`Save changes to ${selectedProduct.prod_name}?`)) return;

              setIsUpdatingProduct(true);
              try {
                const finalDescription = useEnrichedDescription
                  ? enrichedDescription
                  : selectedProduct.enhanced_description || "";

                const currentAttributes = parseAttributes(selectedProduct.attributes);
                const finalAttributes = { ...currentAttributes };
                Object.entries(enrichedAttributes).forEach(([key, value]) => {
                  if (acceptedAttributes[key] === true) finalAttributes[key] = value;
                  else if (acceptedAttributes[key] === false) delete finalAttributes[key];
                });

                // Clean & normalize
                Object.keys(finalAttributes).forEach((key) => {
                  if (typeof finalAttributes[key] === "string" && finalAttributes[key].trim() === "")
                    delete finalAttributes[key];
                });
                if (typeof finalAttributes.occasions === "string") {
                  finalAttributes.occasions = finalAttributes.occasions
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean);
                } else if (Array.isArray(finalAttributes.occasions)) {
                  finalAttributes.occasions = finalAttributes.occasions.filter((s) => s && s.trim());
                }

                const payload = {
                  ...selectedProduct,
                  attributes: finalAttributes,
                  enhanced_description: finalDescription,
                  // Ensure size_list is array
                  size_list: Array.isArray(selectedProduct.size_list)
                    ? selectedProduct.size_list
                    : typeof selectedProduct.size_list === "string"
                    ? selectedProduct.size_list.split(",").map((s) => s.trim()).filter(Boolean)
                    : [],
                };

             

                const result = await updateProduct(payload);
                const updated = result.updated_article;

                setProducts((prev) =>
                  prev.map((p) => (p.article_id === updated.article_id ? updated : p))
                );
                // Also update allProducts if it exists
              
                setSelectedProduct(updated);

                setEnrichedDescription("");
                setEnrichedAttributes({});
                setPromptInput("");
                setUseEnrichedDescription(false);
                setIsDescriptionDiscarded(false);
                setAcceptedAttributes({});

                alert("Product updated successfully!");
              } catch (err) {
                console.error("Save error:", err);
                alert("Save failed: " + (err.message || "Unknown error"));
              } finally {
                setIsUpdatingProduct(false);
              }
            }}
            disabled={isUpdatingProduct}
            className={`px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 ${
              isUpdatingProduct
                ? "bg-blue-400 text-white cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700 shadow"
            }`}
          >
            {isUpdatingProduct ? (
              <>
                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>

    {/* Sign Out Confirmation Modal */}
    {showSignOutModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
        <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
          <h2 className="text-xl font-semibold mb-4">Sign Out</h2>
          <p className="text-gray-700 mb-6">Are you sure you want to sign out?</p>
          
          {isSigningOut ? (
            <div className="flex flex-col items-center gap-4">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              <p className="text-gray-700 font-medium">Signing out...</p>
            </div>
          ) : (
            <div className="flex gap-3 justify-end">
              <button
                onClick={handleCancelSignOut}
                className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                disabled={isSigningOut}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmSignOut}
                className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                disabled={isSigningOut}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    )}
    </>
  );
};

export default AdminPage
